import apiFetch from '../apiFetch'
export default function (token, body) {
  return apiFetch({ endPoint: 'UnattendedProcess/SetOperateActionApprovePurchaseProcess', method: 'POST', body: body, token: token })
}
